import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import Icon from '../Icon/Icon';
import { TypeIconName } from '../Icon/tsx';

export interface Props extends FlexProps {
  /**
   * Active flag that sets the visual state.
   */
  active: boolean;
  /**
   * Name of an icon (from the Icon component) that should
   * appear next to the text.
   */
  icon?: TypeIconName;
  /** onClick event handler. */
  onClick?: (event: React.SyntheticEvent) => void;
}

/**
 * Child of the SidebarSubMenu component that is used to handle the
 * navigation when interacted with.
 */
const SidebarSubMenuItem: React.FunctionComponent<Props> = (props: Props) => {
  const { active, children, icon, onClick, ...rest } = props;
  const classes = classnames('Sidebar__sub-menu-item', {
    'Sidebar__sub-menu-item--active': active,
  });

  const handleClick = (event: React.SyntheticEvent) => {
    event.stopPropagation();

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Flex { ...rest }
        alignChildrenVertical="middle"
        className={ classes }
        direction="horizontal"
        gap="x4"
        onClick={ handleClick }>
      { icon && (
        <Flex>
          <Icon name={ icon } textColor="grape-2" />
        </Flex>
      ) }

      <Flex>
        { children }
      </Flex>
    </Flex>
  );
};

export default SidebarSubMenuItem;
